import ConsentPrompt from './ConsentPrompt'

export default ConsentPrompt
